//#region src/menu_page_designation.ts
let MenuPageDesignation = /* @__PURE__ */ function(MenuPageDesignation) {
	MenuPageDesignation["Regular"] = "regular";
	MenuPageDesignation["SecretMenu"] = "secret-menu";
	MenuPageDesignation["Experiences"] = "experiences";
	MenuPageDesignation["Scanner"] = "scanner";
	MenuPageDesignation["PageNav"] = "page-nav";
	return MenuPageDesignation;
}({});
//#endregion
export { MenuPageDesignation };

//# sourceMappingURL=menu_page_designation.js.map